const baseUrlMapping = {
  localhost: 'http://localhost:4325/mf-manifest.json',
  'simplify.developers.telus.digital': 'https://assets.wcpreview.telus.com/1100769639/simplify-docs-viewer/v1/mf2/mf-manifest.json',
  'simplify.staging.developers.telus.digital': 'https://assets.wcstage.telus.com/1100769639/simplify-docs-viewer/v1/mf2/mf-manifest.json',
  'simplify.telus.com': 'https://assets.telus.com/1100769639/simplify-docs-viewer/v1/mf2/mf-manifest.json',
};

export const docList = {
  remote: 'simplify_hub_docs_viewer_mfe',
  name: 'doc-list',
  source: 'https://github.com/telus/simplify-mfe-components',
  urlMapping: baseUrlMapping,
};

export const docViewer = {
  remote: 'simplify_hub_docs_viewer_mfe',
  name: 'doc-viewer',
  source: 'https://github.com/telus/simplify-mfe-components',
  urlMapping: baseUrlMapping,
};

// Contribute Knowledge page (#4942) — exposed from the same docs-viewer remote.
export const contribute = {
  remote: 'simplify_hub_docs_viewer_mfe',
  name: 'contribute',
  source: 'https://github.com/telus/simplify-mfe-components',
  urlMapping: baseUrlMapping,
};

export default docViewer;
